import Interpretation from "@viz-ui/models/interpretation/interpretation";
import InterpretationAdapter from "@viz-ui/models/interpretation/interpretationAdapter";

angular
  .module("acl.visualizer.model.interpretation", [])
  .factory("Interpretation", () => Interpretation)
  .factory("InterpretationAdapter", () => InterpretationAdapter);
